import { camelCase } from 'lodash-es';

import { generateClassName } from '@klv/shared/utils/functions';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import Image from '@klv/atoms/image';

import * as styles from './styles/productCard.module.scss';

import type { IProductCard } from './types';


export const ProductCard = ({
  buttonText,
  buttonUrl,
  hoverImage,
  mainImage,
  text, 
}: IProductCard) =>  (
  <a
    className={styles.productCard}
    tabIndex={0}
    aria-label={`text: ${text}, image: ${mainImage.altText}`}
    href={buttonUrl}
  >
    <div className={styles.styledButton}>
      {buttonText}
    </div>
    <div className={styles.textContainer}>
      <p className={styles.subHeadline}>
          {text}
      </p>
    </div>
    <div className={styles.imageTextContainer}>
      <div className={styles.imageContainer}>
        <div className={styles.cardImageContainer}>
          <Image imageData={mainImage.gatsbyImage as IGatsbyImageData} altText={mainImage?.altText} />
        </div>
        <div className={generateClassName([
          styles.hoverContainer,
          styles[`${camelCase(buttonText)}HoverImg` as keyof typeof styles],
        ])}>
          <Image imageData={hoverImage.gatsbyImage as IGatsbyImageData} />
        </div>
      </div>
    </div>
  </a>
);

